<template>
	<b-card class="sa-card" header="" header-tag="header" footer-tag="footer" title="">
		<b-row>
			<b-col cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
				<label class="sa-label-data">Nome:</label>
				<b-form-input v-model="jsonData.nome"></b-form-input>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
				<label class="sa-label-data">Versione:</label>
				<b-form-input v-model="jsonData.versione"></b-form-input>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
				<label class="sa-label-data">Data Inizio:</label>
				<date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.dataInizio" type="date"></date-picker>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
				<label class="sa-label-data">Data Fine:</label>
				<date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.dataFine" type="date"></date-picker>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
				<label class="sa-label-data">Descrizione:</label>
				<b-form-textarea v-model="jsonData.descrizione" rows="7"></b-form-textarea>
			</b-col>
		</b-row>
	</b-card>
</template>

<script>
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
	mixins: [UtilityMixin],
	components: { DatePicker },
	data() {
		return {
			id: null,
			pathResource: "/gestioneattivitamoduli",
			jsonData: { nome: "", descrizione: "", dataInizio: null, dataFine: null },
		};
	},
	mounted() {
		this.id = this.$route.params.id;
		if (this.id !== "-1") {
			this.loadData();
		}
	},
	watch: {
		jsonData: {
			handler(jsonData) {
				this.$emit("updateJsonData", jsonData);
			},
			deep: true,
		},
	},
	methods: {
		loadData() {
			let me = this;
			me.$emit("beforeLoadData");
			UtilityMixin.methods.loadDataResources(me.pathResource + "/" + me.id, {}, me.loadDataSuccess, me.loadDataError);
		},
		loadDataSuccess(response) {
			let me = this;
			me.jsonData = response.data.data;
			me.$emit("afterLoadData");
		},
		loadDataError(error) {
			let me = this;
			console.log(error);
			me.$emit("afterLoadData");
		},
	},
};
</script>

<style></style>
